import React, {
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
import {
  FeatureFlagsProvider, LoaderWidget, RootProvider, ServicesProvider, useFeatureFlagsContext, useServicesContext,
} from '@jarvis/react-portal-addons';
import resources from './assets/locale/index';
import DashboardComponent from './components/Dashboard/index';
import AdminConsolidatedDashboard from './components/ConsolidatedDashboard/AdminDashboard';
import EndUserConsolidatedDashboard from './components/ConsolidatedDashboard/EndUserDashboard';

const App = props => {
  const { consolidatedPortalDashbordLayout, consolidatedPortalDashboardEndUser } = useFeatureFlagsContext();
  const { pending: servicesPending } = useServicesContext();
  const { shell: { userService } } = props;

  const authData = userService.getAuthenticationData();
  const { tenantData } = authData;
  const { roleCategory } = tenantData;

  const isEndUser = roleCategory === 'User';

  if (servicesPending && consolidatedPortalDashbordLayout) {
    return <LoaderWidget fullScreen />;
  }

  if (!consolidatedPortalDashbordLayout) {
    return <DashboardComponent {...props} />;
  }

  if (isEndUser && consolidatedPortalDashboardEndUser) {
    return <EndUserConsolidatedDashboard />;
  }

  return <AdminConsolidatedDashboard />;
};

const Dashboard = props => {
  const { shell, stack } = props;

  const localization = shell?.localization || {};

  const flags = useMemo(
    () => [
      { key: 'consolidatedPortalDashboardEndUser' },
      { key: 'consolidatedPortalDashbordLayout' },
      { key: 'consolidatedPortalGetAppButton' },
      { key: 'consolidatedPortalGetHpAppCard' },
      { key: 'consolidatedPortalHpAllInCard' },
      { key: 'consolidatedPortalInstantInkCard' },
      { key: 'consolidatedPortalPrinterCarousel' },
      { key: 'consolidatedPortalSustainabilityCard' },
      { key: 'consolidatedPortalUsageDataTelemetryCheck' },
      { key: 'dashboardDetailUsageModalPrinterClick' },
      { key: 'dashboardHideColumnReorder' },
      { key: 'dashboardHideSegmentedControl' },
      { key: 'dashboardPrintAnywhereV2' },
      { key: 'dashboardShowFiltersDetailedUsage' },
      { key: 'dashboardShowNoDataYet' },
      { key: 'dashboardUsageDataUnitFromOrg' },
      { key: 'grantsSupport' },
      { key: 'printerSecurityRename' },
      { key: 'smartSecurityRemoval' },
    ],
    [],
  );

  return (
    <FeatureFlagsProvider
      clientKey="smb-portal"
      flags={flags}
    >
      <RootProvider
        stack={stack}
        shell={shell}
        localization={localization}
        resources={resources}
      >
        <ServicesProvider shell={shell} stack={stack}>
          <App {...props} />
        </ServicesProvider>
      </RootProvider>

    </FeatureFlagsProvider>
  );
};

Dashboard.defaultProps = {
  shell: {},
};

Dashboard.propTypes = {
  shell: PropTypes.objectOf(PropTypes.any),
  stack: PropTypes.number.isRequired,
};

App.propTypes = {
  shell: PropTypes.objectOf(PropTypes.any).isRequired,
  stack: PropTypes.number.isRequired,
};

export default Dashboard;
